import { IDocumentFolderModel } from '@api/models';
import { LoadingButton } from '@components/buttons';
import { Button, Drawer, Label } from '@hyperflake/react-ui-library';
import { FormHelperText } from '@library/forms';
import { ErrorMessage, Form, Formik } from 'formik';
import useUpdateFolderForm from 'modules/documents/hooks/useUpdateFolderForm';
import { FormikInput } from 'modules/shared/features/formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

interface EditFolderDrawerProps {
    clientId: string;
    show: boolean;
    onClose: () => void;
    folder: IDocumentFolderModel;
    onUpdate: (folderId: string, updates: IDocumentFolderModel) => void;
}
export const EditCategorySchema = Yup.object({
    name: Yup.string().trim().required('This field is required'),
});

const EditFolderDrawer = (props: EditFolderDrawerProps) => {
    const { show, onClose, folder, onUpdate, clientId } = props;

    const updateFolderForm = useUpdateFolderForm({ clientId, folder });

    const handleSubmit = async (values: Pick<IDocumentFolderModel, 'name'>) => {
        try {
            const updatedFolder = await updateFolderForm.submit(values);

            onUpdate(folder._id, { ...folder, name: updatedFolder.name });

            // Close drawer
            onClose();

            toast.success('Folder updated successfully.');
        } catch (err: any) {
            toast.error(err.data.message || 'Some error occurred, please try again.');
        }
    };

    return (
        <Drawer open={show} onClose={onClose}>
            <div className="flex flex-col h-[calc(100dvh-3rem)]">
                <h4>Rename Folder</h4>

                <div className="mt-6">
                    <Formik
                        initialValues={updateFolderForm.initialValues}
                        validationSchema={EditCategorySchema}
                        enableReinitialize
                        onSubmit={handleSubmit}
                    >
                        <Form id="updateFolderForm">
                            <div>
                                <Label htmlFor="name">Name</Label>
                                <FormikInput name="name" placeholder="Enter text here" />

                                <FormHelperText variant={'error'}>
                                    <ErrorMessage name="name" />
                                </FormHelperText>

                                {/* <ErrorMessage component="div" className="form-error-message" name="name" /> */}
                            </div>
                        </Form>
                    </Formik>
                </div>

                <div className="mt-auto">
                    <div className="flex gap-4 mt-6">
                        <Button type="button" size="sm" color="secondary" className="font-medium" onClick={onClose}>
                            Cancel
                        </Button>

                        <LoadingButton
                            type="submit"
                            size="sm"
                            form="updateFolderForm"
                            isLoading={updateFolderForm.isLoading}
                            loadingText="Saving"
                        >
                            Save
                        </LoadingButton>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default EditFolderDrawer;
